import { connect } from "react-redux"
import { Dispatch } from "redux"
import { getCurrentUser } from "../../../../libs/get-current-user"
import { RootState } from "../../../../reducers"
import { Channel } from "../../../../rpcs/dist/ChannelRPC"
import { User } from "../../../../rpcs/dist/UserRPC"
import { ActionDispatcher } from "../../actiondispacher/action-dispacher"

export interface IContainerProps {
  selectedChannelId: Channel["id"] | null
  channels: Channel[] | null
  currentUser: User | null
  actions: ActionDispatcher
}

const mapStateToProps = ({
  pages,
  loginData,
  switchingUser,
}: RootState): Omit<IContainerProps, "actions"> => ({
  selectedChannelId: pages.editor.currentEditingState.selectedChannelId,
  channels: pages.editor.fetchData.channels,
  currentUser: getCurrentUser(loginData, switchingUser),
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: new ActionDispatcher(dispatch),
})

export const Container = connect(mapStateToProps, mapDispatchToProps)
